module.exports = __webpack_public_path__ + "static/media/workingmemory-words-3.dbd42ad8.mp3";